import { Code } from './../../core/model/dictionary';

export class GoalEdit
{
    public id: number = null;
    public memberId = null;
    public goal = null;
    public type = null;
    public progress = null;
    public goalId = null;
    public actionPlan = null;
    public caseId = null;
}

export class Goal
{
    public id: number = null;
    public memberId: number;
    public goal: string;
    public type: Code;
    public progress: Code;
    public goalId: number;
    public actionPlan: string;
    public caseId: number;
}